/**
 * @requires ../../../../../../../../node_modules/pensions-portals-fe/nnip/js/nnip/base.js
*/

nnip.classes.StepWizard = function(indicatorClass, config) {

     "use strict";

    /*Variables*/
    var stepIndicatorTop = $(indicatorClass+' .nav-top');
    var stepIndicatorBottom = $(indicatorClass+' .nav-bottom');
    var activeClass = 'current';
    var visitedClass = 'visited';
    var totalSteps = config.stepNumberToId.length;
    var stepNumberToIdMapping = config.stepNumberToId;
    var skippedSteps = []; 
    var flowType = config.type;

    var WizardObject = function(){
    	this.steps = new Step();
        this.total = totalSteps;
    }

    var Step = function () {
        this.activeStep = 1;
    }
    
     var setupMustache = function(templates, targetTemplate, target) {        
		globalStore[target] = $(templates).filter(targetTemplate).html();    
        Mustache.parse(globalStore[target]);
	} 

    this.updateStep = function (activatedStep) {
            $(stepIndicatorTop).find('li:nth-child(-n+'+(activatedStep-1)+')').addClass(visitedClass);
            $(stepIndicatorBottom).find('li:nth-child(-n+'+(activatedStep-1)+')').addClass(visitedClass);        
            $(stepIndicatorTop).find('li:nth-child(-n+'+(activatedStep-1)+')').removeClass(activeClass).removeClass('active');
            $(stepIndicatorBottom).find('li:nth-child(-n+'+(activatedStep-1)+')').removeClass(activeClass).removeClass('active');
        
            $(stepIndicatorTop).find('li:nth-child('+(activatedStep)+')').addClass(activeClass);
            $(stepIndicatorBottom).find('li:nth-child('+(activatedStep)+')').addClass(activeClass);
        
            $(stepIndicatorTop).find('li:nth-child(n+'+(activatedStep+1)+')').removeClass(activeClass ).removeClass('active');
            $(stepIndicatorTop).find('li:nth-child(n+'+(activatedStep+1)+')').removeClass(visitedClass).removeClass('active');
            $(stepIndicatorBottom).find('li:nth-child(n+'+(activatedStep+1)+')').removeClass(activeClass).removeClass('active');
            $(stepIndicatorBottom).find('li:nth-child(n+'+(activatedStep+1)+')').removeClass(visitedClass).removeClass('active');
            
            StepWizardObject.steps.activeStep = activatedStep;
    }
    
    this.updateAssetsModalButtons = function (assetObjectId) {

        var currentObject = $('#'+assetObjectId);
        var currentType = currentObject.data('type');
        var nextRepresentation = currentObject.closest('.row-fluid').next().find('button[data-type='+currentType+']');
        var PrevRepresentation = currentObject.closest('.row-fluid').prev().find('button[data-type='+currentType+']');

        if(!nextRepresentation.length){
            $('#dismissButton').show(); 
            $('#nextAssetButton').hide();
            
        } else {
            var assetLink = nextRepresentation.attr("onclick");
            $('#dismissButton').hide();
            $('#nextAssetButton').show();
            $('#nextAssetButton').attr('onclick', assetLink);            
        }
        
        if(!PrevRepresentation.length){
            $('#previousAssetButton').attr('disabled','disabled');
        } else {
            var assetLink = PrevRepresentation.attr("onclick");
            $('#previousAssetButton').prop('disabled',false);
            $('#previousAssetButton').attr('onclick', assetLink);
        }        
        
    }
    
    this.getActiveStep = function (){
        return StepWizardObject.steps.activeStep;
    }

    this.getSkippedSteps = function (){
        return skippedSteps;
    }
    
    this.getNextStep = function(ltr) {
        
        
        var skippedSteps = wizard.getSkippedSteps();
        var totalSteps = wizard.getStepWizard().total;
        var activeStep = wizard.getActiveStep();
        var movingLtr = ((ltr === 'ltr') ? true : false);
        
        /* TODO: Start using underscore for improving this function */
        if(skippedSteps.length && movingLtr){
            activeStep = activeStep + 1;
            for(var i=activeStep; i<=totalSteps; i++){
                if((skippedSteps.indexOf(i))>=0){
                    continue;
                }else{
                    activeStep = i;
                    break;
                }
            }
        } else if(skippedSteps.length && !movingLtr){
            activeStep = activeStep - 1;
            for(var i=activeStep; i>=0; --i){
                if((skippedSteps.indexOf(i))>=0){
                    continue;
                }else{
                    activeStep = i;
                    break;
                }
            }
        } else {
            activeStep = (movingLtr ? (activeStep + 1) : (activeStep - 1)); 
        }
        return activeStep;
    }

    this.skipSteps = function (steps){
        skippedSteps.length = 0;
        if(steps.length){
           steps.forEach(function(val) {
                skippedSteps.push(val);
            }); 
        } 
    }

    // returns StepWizard object
    this.getStepWizard = function() {
        return StepWizardObject;
    };
    
    this.getTemplates = function(file, targetTemplate, target){    
        var mustacheReturnTemplate;   
        var cookieSaltValue = cookieUtil.getCookie("csrfPreventionSaltCookie");
		$.ajaxSetup({
			cache: false,
			headers: { 'csrfPreventionSalt': cookieSaltValue }
		});
    	$.when(					
    		$.get(file, function(templates) {
    			mustacheReturnTemplate = templates;
    		})
    	).then(function() {
    		setupMustache(mustacheReturnTemplate, targetTemplate, target);
    	});		
    };     
    
    this.getStepIdForNumber = function (stepNumber) {
		var mappedStep = _.find(stepNumberToIdMapping, function(mappingEntry) {
			return mappingEntry.number == stepNumber;
		});

        return mappedStep.id;
    };

    this.getActiveStepId = function () {
		var mappedStep = _.find(stepNumberToIdMapping, function(mappingEntry) {
			return mappingEntry.number == StepWizardObject.steps.activeStep;
		});

        return mappedStep.id;
    };    

    this.getFlowType = function () {
        return flowType;
    };     
    
    this.setTemplate =  function(target, template, asset, partialTemplate) {
        var rendered = Mustache.render(template, asset, {"assetPartial": partialTemplate} );
        $(target).html(rendered);        
    };
    
    this.validateStep = function(step){

        var docButtonsObj = $('#step'+step).find('button');  
        var disabledCount = 0;        
        var disabledButtonsObj = _.filter(docButtonsObj, function(button){ 
                                    return $(button).data('completed') === false; 
                                 });
        
        disabledCount = disabledButtonsObj.length;
        
        var riskProfileTabActive = $('#investmentProfile:visible').length;
        var retainPortfolioProfileTabActive = $('#retainPortfolioProfile:visible').length;
        var selectAccountTabActive = $('#accountList:visible').length;
        var portfolioTabActive = $('#investmentPortfolio:visible').length;        
                
        if(disabledCount === 0 && !globalStore.isErrorOccured){
            
            if($('#step'+step+':visible').length !== 0){
                $('#next').prop('disabled', false);
                $('input:visible:disabled:not([data-pendingorder])').prop('disabled', false);

            }
        } else {

            $('#next').attr('disabled','disabled');
            $('input:visible').attr("disabled", "disabled");            
        }
        
        if(riskProfileTabActive){
            if(typeof(globalStore.selectedRiskProfile) === 'undefined'){
                $('#next').attr('disabled','disabled');
            }else {
                $('#next').prop('disabled', false);
            }
        }
        
        if(selectAccountTabActive) {            
            if($("input[name='accountnumber']:checked").length >= 1){
                $('#next').prop('disabled', false);
                $('#previous, #stop').addClass('hidden');
            } else {
                $('#next').attr('disabled','disabled');
            }            
        } else {
            $('#previous, #stop').removeClass('hidden');
        }
        
        if (portfolioTabActive) {
        	calculateTotalPercentage($('.tablecountpercentage input.sum'));
        }
        
        //var nextActiveBlock = $('#step'+step).find("[class*='assetBlock']").find('button[disabled]').first().parents('.row-fluid');
        var nextActiveBlock = $('#step'+step).find("[class*='assetBlock']").find('button');
        nextActiveBlock = _.find(nextActiveBlock, function(button){return $(button).data('completed') === false;});
        nextActiveBlock = $(nextActiveBlock).parents('.row-fluid');

        // by default enable first block
        $(nextActiveBlock).find('button[disabled]').prop('disabled',false);
        
        if(riskProfileTabActive && $(nextActiveBlock).length === 0){
            $('#step'+step).find('.assetBlock').find('button[disabled]').prop('disabled',false);
        }

        if(retainPortfolioProfileTabActive && $(nextActiveBlock).length === 0){
            $('#step'+step).find('.assetBlock').find('button[disabled]').prop('disabled',false);
        }

        if (StepWizardObject.steps.activeStep == totalSteps) {
            $('#next').attr('disabled','disabled');
            $('#submit').prop('disabled',false);
        }
        
    }
    
    // load or create new wizardObject
    var StepWizardObject = new WizardObject();

}